<div id="dashboard-topbar-user">
    <div id="user-avatar" data-test="topbar-user-shortname">
        {{ shortName }}
    </div>
    <div id="user-information" class="d-none d-md-block">
        <div id="user-information-name" class="t-m t-18" data-test="topbar-user-fullname">{{ fullname }}</div>
        <div id="user-information-id" class="t-13" data-test="topbar-user-login">ID: {{ representative?.login }}</div>
    </div>
</div>
